export function getAbsoluteURI(path: string) {
    const base_uri = window.location.origin;
    return `${base_uri}${path}`;
}
